export default (router, store) => {
  router.beforeEach((to, from, next) => {
    if (to.name === 'Show') {
      store.dispatch('metrics/resetChartData');
    }
    next();
  });
};



// WEBPACK FOOTER //
// ./src/router/watcher.js